import {Inject, Injectable} from '@angular/core';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {environment, CustomEnvironment, setApiOverrides} from '../../environments/environment';
import {Observable} from 'rxjs';
import {HttpErrorHandlerService, HandleError} from './http-error-handling.service';
import {HistoryService} from './history.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import {FmcLibraryNotificationService} from './notification.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class VxCoreService {
  private handleError: HandleError;
  private userDetails: any;
  public staffPermission = false;

  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              private historyService: HistoryService,
              private notificationService: FmcLibraryNotificationService,
              httpErrorHandler: HttpErrorHandlerService,
              @Inject(CustomEnvironment) customEnvironment: any) {
    setApiOverrides(customEnvironment);

    this.oauthService.events.subscribe((event: OAuthEvent) => {
      const tokenUpdatedEvents = ['token_refreshed', 'token_received', 'silently_refreshed'];
      if (tokenUpdatedEvents.includes(event.type)) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
      }
    });

    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('VxCoreService');

    this.checkIdentityClaims();
  }


  /**
   * Check user level permissions from the JWT token
   */
  public checkIdentityClaims() {
    this.userDetails = this.oauthService.getIdentityClaims();
    if (!this.userDetails) {
      const helper = new JwtHelperService();
      const rawToken = sessionStorage.getItem('access_token');
      const decodedToken = helper.decodeToken(rawToken);

      if (decodedToken && decodedToken.perms.split(',').find(x => x === 'search:view-staff')) {
        this.staffPermission = true;
      } else {
        this.staffPermission = false;
      }
    } else if (this.userDetails && this.userDetails.perms.split(',').find(x => x === 'search:view-staff')) {
      this.staffPermission = true;
    } else {
      this.staffPermission = false;
    }
  }

  /**
   * Update app status
   * @param appId the app ID
   * @param statusSlug vx status slug
   * @param data status Body
   * @returns {Observable<A>}
   */
  updateAppStatus(appId, statusSlug, data) {
    return this.http.post<any[]>(`${environment.api.vxCore}/applications/${appId}/status/${statusSlug}`, data, httpOptions);
  }
}
